exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3UAH9asmDP90DEqm0bRkN6{display:block;white-space:nowrap;overflow:hidden;width:100%;position:relative}._3J6FyxrWM3EN7k_bkg5dCw{max-width:calc(100% - 140px);overflow:hidden;text-overflow:ellipsis;display:inline-block}html[dir=ltr] ._3J6FyxrWM3EN7k_bkg5dCw{text-align:right}html[dir=rtl] ._3J6FyxrWM3EN7k_bkg5dCw{text-align:left}._3J6FyxrWM3EN7k_bkg5dCw._11maAyxRfNEqKM9oIQzHD8{max-width:calc(100% - 16px)}", ""]);
// Exports
exports.locals = {
	"truncatedRecipientsContainer": "_3UAH9asmDP90DEqm0bRkN6",
	"truncatedOnlyChildRecipient": "_3J6FyxrWM3EN7k_bkg5dCw",
	"noTruncatedRecipients": "_11maAyxRfNEqKM9oIQzHD8"
};